const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

let reloadScheduled = false;

export function scheduleAppReload(reason = 'update') {
  if (reloadScheduled) {
    return;
  }

  reloadScheduled = true;
  console.log(`[PWA] Reloading app (${reason})`);

  window.setTimeout(() => {
    window.location.reload();
  }, 300);
}

export function checkForServiceWorkerUpdate() {
  if (!('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }

  return navigator.serviceWorker.getRegistration().then((registration) => {
    registration?.update();
    return registration;
  });
}

function runWhenPageLoaded(callback) {
  if (document.readyState === 'complete') {
    callback();
    return;
  }

  window.addEventListener('load', callback);
}

export function register(config) {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  runWhenPageLoaded(() => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      navigator.serviceWorker.ready.then(() => {
        console.log('[PWA] Service worker ready (localhost).');
      });
      return;
    }

    registerValidSW(swUrl, config);
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('[PWA] New content available; refreshing app.');
              config?.onUpdate?.(registration);
            } else {
              console.log('[PWA] Content cached for offline use.');
              config?.onSuccess?.(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Service worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      if (
        response.status === 404 ||
        !response.headers.get('content-type')?.includes('javascript')
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
        return;
      }
      registerValidSW(swUrl, config);
    })
    .catch(() => {
      console.log('[PWA] No internet connection. App running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
